import App from '../components/app'
import DivBottom from '../components/divBottom'
import NavbarNotAuth from '../components/navbarNotAuth'
import NavbarTopAdmin from '../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../admin/components/navbarBottomAdmin'

function Roma() {
    return (<>
        {localStorage.getItem('logged') && localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <div style={{marginTop:'6rem'}}></div>
        <App />
        <div style={{ marginBottom: '50px' }}>
            <div style={{
                textAlign: 'center',
                padding: '3rem 0rem 1rem 0rem'
            }}>
                <h1>Roma</h1>
                <h5 style={{ color: 'grey', position: 'relative' }}>LAZIO
                    <span style={{
                        position: 'absolute',
                        left: '1rem',
                        backgroundColor: 'maroon',
                        color: 'whitesmoke',
                        padding: '3px',
                        borderRadius: '5px'
                    }}>ARTE
                    </span>
                </h5>
            </div>

            {/* {foto && */}
                <div className='mt-1'>
                    <div className='galleria container-fluid'>
                        <div className='gbox1'>
                            <img src={require('../image/caleb-miller-0Bs3et8FYyg-unsplash.jpg')}
                                alt='' height='100%' width='100%' />
                        </div>
                        <div className='gbox2'>
                            <h4>La città eterna</h4><hr />
                            <p className='mt-3'>
                                La convinzione degli antichi romani che il loro impero fosse insopprimibile e che la loro città sarebbe durata
                                per l'eternità etichettò Roma come <b>Città Eterna</b>. Non da meno è la sua religione, che con il passare dei milenni
                                è ancora praticata in buona parte del paese ed attira milioni di fedeli tutto l'anno.
                            </p>
                            <hr />
                            <p>
                                <b>Roma</b>, la capitale d'Italia, conserva sorprendentemente alcune delle <b>meraviglie architettoniche </b>
                                uniche al mondo e rappresentano la resilienza e la capacità che questa città ha di evolversi attraverso i secoli.
                                Fondata nel 753 a.C. e proclamata successivamente Repubblica Romana, si espanse a tal punto
                                da diventare uno degli <b>imperi</b> più influenti e prestigiosi della storia.
                                Nel 27 a.C. con l'imperatore <b>Cesare Augusto</b> Roma conobbe un periodo d'oro e la sua area di dominio
                                andava dalla Britannia al Medio Oriente. Nel 70 d.C. l'imperatore Vespasiano iniziò la costruzione del <b>Colosseo</b>, un anfiteatro in grado di contenere
                                fino a 50000 spettatori che intratteneva la vita sociale romana e dove venivano inscenati spettacoli e combattimenti
                                tra i gladiatori. La caduta dell'impero romano risale al 476 d.C. ma non per questo Roma perse importanza in quanto acquisì fama
                                e notorietà sotto l'egemonia bizantina e papale.

                            </p>
                        </div>
                        <img src={require('../image/chris-czermak-gZKzBhsO6KY-unsplash.jpg')}
                            alt='' className='galleria_immagine addImg' />
                        <img src={require('../image/claudio-hirschberger-HI5c2A-LOqs-unsplash.jpg')}
                            alt='' className='galleria_immagine addImg' />
                    </div>

                    <p className='m-3'>
                        Grazie alla sua storia millenaria, al suo fascino e alla sua cultura, <b>Roma</b> è una delle meraviglie del nostro pianeta che con
                        le sue attrazioni architettoniche e culturali ha affascinato e conquistato il cuore di milioni di turisti.
                        In epoca antica ha ispirato poeti, scrittori, filosofi e in tempi più recenti anche registi e personaggi famosi dell'arte
                        per creare le loro opere.
                    </p>

                    <div className='container mt-2'>

                        <div className='divCittà mt-5'>
                            <h1 className='text-center'>COLOSSEO</h1>
                            <img src={require('../image/david-kohler-VFRTXGw1VjU-unsplash.jpg')}
                                alt='' className='imgCittà' />
                            <br />
                            <p className='mt-3'>
                                Il <b>Colosseo</b>, o Anfiteatro Flavio, è un'anfiteatro ovale lungo 189 metri, largo 156 metri e alto oltre 48 metri,
                                si estende su una superficie di 24.000 mq, può ospitare circa 50mila spettatori ed è il più <b>grande mai costruito</b>.<br />
                                Svariati spettacoli furono inscenati nell'arena e non mancarano quelli più crudeli come la caccia alle
                                belve feroci, l'esecuzione dei condannati a morte e il combattimento tra i <b>gladiatori</b> (il più bramato dagli spettatori).
                                Il Colosseo fu voluto dall'imperatore <b>Tito Flavio Vespasiano</b> che ne iniziò la costruzione nel 70 d.C. e
                                fu concluso da <b>Tito</b> nell'80 d.C.
                                Un luogo incantevole, un monumento sorprendete e maestoso, non puoi andare a Roma e non fare visita a questa meraviglia!
                            </p>
                        </div>

                        <div className='divCittà mt-5'>
                            <h1 className='text-center'>PANTHEON</h1>
                            <img src={require('../image/daniel-klaffke-rDA5DC3Fu7o-unsplash.jpg')}
                                alt='' className='imgCittà' />
                            <br />
                            <p className='mt-3'>
                                Il <b>Pantheon</b> fu fondato come tempio di tutte le divinità nel 27 a.C. da <b>Agrippa</b> ed è l'edificio
                                romano meglio conservato al mondo, è un connubio di armonia e sapienza costruttiva e bisognerà aspettare il
                                Rinascimento per vedere opere di simile fattezza.
                                Michelangelo, quattordici secoli dopo la sua costruzione, descrisse il Pantheon come ad un edificio che aveva
                                <b> un disegno angelico e non umano</b>. <br />
                                Questo tempio conserva ancora il suo pavimento originale in marmo e nelle cappelle interne si possono ammirare
                                numerose opere d'arte.
                                Il Pantheon di Agrippa fu distrutto da un incendio nel 80 d.C. e fu fatto ricostruire dall'imperatore <b>Adriano</b>.
                                E' una delle attrazioni più famose di Roma e il fascino maggiore è all'interno per la nota cupola,
                                capolavoro d'ingegneria romana!
                            </p>
                        </div>

                        <div className='divCittà mt-5'>
                            <h1 className='text-center'>FONTANA DI TREVI</h1>
                            <img src={require('../image/mike-hsieh-964h9mxdKp4-unsplash.jpg')}
                                alt='' className='imgCittà' />
                            <br />
                            <p className='mt-3'>
                                In stile tardo <b>barocco</b>, è la più famosa e celebre tra le oltre 2000 fontane che abbelliscono
                                le strade e le piazze di Roma. Ha un'altezza massima si 26.3 metri e una larghezza di 49.15 metri.
                                L'architetto e scultore <b>Nicola Salvi</b>, su commissione del papa Clemente VII, iniziò l'opera nel
                                1732 poi completata da Pietro Bracci nel 1762.
                                La fontana di Trevi, costruita sulla facciata di Palazzo Poli, è composta da una vasca rettangolare
                                dagli angoli arrotondati e da una scogliera rocciosa che da importanza alla scenografia.
                                Al centro troviamo una nicchia dove si erge la statua della divinità Oceano.
                                Il prospetto è costituito da tre tre elementi architettonici:
                                <li>facciata in travertino</li>
                                <li>complesso di statue in marmo di carrara</li>
                                <li>scogliera in travertino</li>
                                La fontana è uno spettacolo unico, <b>meravigliosa, maestosa ed affascinante</b>.
                            </p>
                        </div>

                        <div className='divCittà mt-5'>
                            <h1 className='text-center'>PIAZZA NAVONA</h1>
                            <img src={require('../image/tamal-mukhopadhyay-iiFF48B50VY-unsplash.jpg')}
                                alt='' className='imgCittà' />
                            <br />
                            <p className='mt-3'>
                                Luogo di spettacoli, corse e giostre della Roma barocca, questa piazza è uno dei complessi urbanistici
                                più spettacolari, unici e caratteristici.

                                La piazza è resa importante dalla chiesa di <b>Sant'Agnese</b> in Agone, iniziata da Carlo e Girolamo Rainaldi
                                e portata a termine dal Borromini, che modificandola sensibilmente, la trasformò in una delle più splendide
                                architetture barocche della città.
                                Tre fontane ornano la piazza: la <b>Fontana del Moro</b>, la <b>Fontana de' Calderari</b> e, al centro, l'imponente <b>Fontana
                                    dei Quattro Fiumi</b>, opera di Gian Lorenzo Bernini che rappresenta i quattro fiumi principali della terra:
                                il Danubio, il Gange, il Nilo e il Rio de la Plata.<br />
                                Piazza Navona è un autentico capolavoro ma anche tutti i vari palazzi che la circondano fanno la loro parte.
                                Da visitare.
                            </p>
                        </div>

                        <div className='divCittà mt-5'>
                            <h1 className='text-center'>PIAZZA SAN PIETRO</h1>
                            <img src={require('../image/caleb-miller-0Bs3et8FYyg-unsplash.jpg')}
                                alt='' className='imgCittà' />
                            <br />
                            <p className='mt-3'>
                                Famosa in tutto il mondo, deve la sua particolare forma ellittica al maestoso colonnato di <b>Gian Lorenzo Bernini</b>.
                                Fulcro della cristianità mondiale e abbraccio universale della Chiesa ai fedeli, <b>Piazza San Pietro</b> fu costruita in undici anni di lavoro (1656-1667).
                                con l'utilizzo di oltre 40mila metri cubi di travertino trasportati dai cavalli.
                                L'imponente Basilica di San Pietro, edificata in circa 200 anni e contenente opere di valore inestimabile, domina la piazza.
                                Dalla basilica emerge la cupola cinquecentesca progettata da <mark>Michelangelo</mark> e completata da <b>Giacomo Della Porta </b>
                                e <b>Domenico Fontana</b>.
                                L'interno conserva capolavori eseguiti dai più grandi artisti della storia dell'epoca tra cui
                                <b> Bernini, Maderno, Borromini, Canova, il Cavalier d'Arpino</b> e luoghi di grandissimo valore storico e religioso,
                                come le Grotte Vaticane e la Necropoli, dove si trova la <b>tomba di San Pietro</b>.
                                Conosciuti in tutto il mondo sono anche i <mark>Musei Vaticani</mark> che custodisce sculture greche e romane,
                                arazzi, antichità egizie, preziosi affreschi e opere di artisti come <b>Giotto, Beato Angelico, Filippo Lippi,
                                    Perugino, Pinturicchio, Tiziano, Carracci, Caravaggio, Poussin, Reni e Guercino</b>. Altro luogo di inestimabile valore
                                artistico è la Cappella Sistina, sede del Conclave per l'elezione del Sommo Pontefice, dove potrete contemplare il
                                magnifico affresco del <mark>Giudizio Universale di Michelangelo</mark>.
                                Una meraviglia indescrivibile!
                            </p>
                        </div>
                        <div className='divCittà mt-5'>
                            <h1 className='text-center'>GASTRONOMIA</h1>
                            <img src={require('../image/claudio-hirschberger-HI5c2A-LOqs-unsplash.jpg')}
                                alt='' className='imgCittà' />
                            <br />
                            <p className='mt-3'>
                                I primi piatti romani utilizzano principalmente tre ingriedenti: pepe, guanciale e pecorino romano.
                            </p>
                            <ul>
                                <li>
                                    <b>Bucatini all'amatriciana</b>, sono molto saporiti!
                                </li>
                                <li>
                                    <b>Gnocchi alla romana</b>, piatto tipico laziale.!
                                </li>
                                <li>
                                    <b>Spaghetti alla carbonara</b>, conosciuti in tutto il mondo.
                                </li>
                                <li>
                                    <b>Cacio e pepe</b>, una bontà unica e insostituibile.
                                </li>
                                <li>
                                    <b>Rigatoni alla vaccinara</b>, semplici da fare vi delizieranno!
                                </li>
                                <li>
                                    <b>Penne all'arrabbiata</b>, il segreto è il peperoncino!
                                </li>
                            </ul>
                            Secondi piatti della cucina romana:
                            <ul>
                                <li>
                                    <b>Pinsa romana</b>, morbida dentro e croccante fuori!
                                </li>
                                <li>
                                    <b>Carciofi alla giudia</b>, sfizioso e...fritto!
                                </li>
                                <li>
                                    <b>Trippa alla romana</b>, un'esplosione di sapori!
                                </li>
                                <li>
                                    <b>Fagioli con le cotiche</b>, un piatto antico con sapori intensi.
                                </li>
                            </ul>
                            Dolci tipici romani:
                            <ul>
                                <li>
                                    <b>Maritozzi con la panna</b>, dalla tradizione romana.
                                </li>
                                <li>
                                    <b>Biscotti al vino</b>, da assaporare insieme al vino dolce.
                                </li>
                                <li>
                                    <b>Gelato alla ricotta</b>, ...buonissimo se la ricotta è fresca.
                                </li>
                            </ul>
                        </div>

                        <div className='divCittà mt-5'>
                            <h1 className='text-center'>FORI IMPERIALI</h1>
                            <img src={require('../image/anna-church-KUnkswI9IFY-unsplash.jpg')}
                                alt='' className='imgCittà' />
                            <br />
                            <p className='mt-3'>
                                E' una <mark>zona archeologica</mark> formata dalla sedimentazione dei resti dell'antica Roma prevalentemente composta da
                                edifici politici, governativi, religiosi e di vita sociale di epoche diverse.
                                Nel sito archeologico merita sicuramente una visita più accurata la <b>Domus Tiberiana</b> chè stato il primo
                                palazzo imperiale ad essere edificato sulle pendici del colle del Palatino.<br />
                                La visita ai <b>Fori imperiali</b> è una tappa fondamentale se si visita la città e passeggiare tra i suoi resti
                                sarà come immergersi nella storia dell'antica Roma.
                                Un luogo magico in un'atmosfera magica!
                            </p>
                        </div>
                    </div>
                </div>
            {/* } */}

            <DivBottom />
        </div >
    </>
    )
}
export default Roma